export const getFonts= () =>
  fetch(
    `https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyB7EWqbtP-nTFib111i-MrYyGZ9LzsjOi8`,
    {
      method: 'GET'
    }
  )
  .then(res => res.json())